import { SEATMAP_FLATBED, SEATMAP_COMFY_LEGROOM, SEATMAP_ONDEMAND_TV } from "@ibe.config";

export const BUSINESS_A330 = {
	features: [
		SEATMAP_FLATBED,
		SEATMAP_COMFY_LEGROOM,
		SEATMAP_ONDEMAND_TV
	]
};

export const BUSINESS_A321LR = {
	features: [
		SEATMAP_FLATBED,
		SEATMAP_COMFY_LEGROOM,
		SEATMAP_ONDEMAND_TV
	]
};

export const BUSINESS_A320NEO = {
	features: [
		SEATMAP_FLATBED,
		SEATMAP_COMFY_LEGROOM,
		SEATMAP_ONDEMAND_TV
	]
};

export const BUSINESS_A330NEO = {
	features: [
		SEATMAP_FLATBED,
		SEATMAP_COMFY_LEGROOM,
		SEATMAP_ONDEMAND_TV
	]
};

export const BUSINESS_DEFAULT = {
	features: [
		SEATMAP_COMFY_LEGROOM
	]
};
